import { useEffect, useState } from 'react';

import { analyzeImage } from '@helpers';
import classnames from 'classnames';

import { IconButton } from '@material-ui/core';
import { AddCircle, Info as InfoIcon } from '@material-ui/icons';

import NibButton from '@components/common/NibButton/NibButton';

import ImageCropper from '../ImageCropper/ImageCropper';
import css from '../NibCard/NibCardImage/nibCardImage.module.sass';
import NibFileSelector from '../NibFileSelector/NibFileSelector';

const NInputImage = ({
  formik,
  name,
  label = '',
  desc = '',
  helperText,
  accept = ['.jpg', '.png', '.jpeg'],
  useCropper = false,
  customeText = '',
  withBoxBg = false,
  withAddBtn = true,
  ...props
}) => {
  const [bgColor, setBgColor] = useState('transparent');

  const getSrc = () => {
    if (!formik.values[name]) return false;
    if (formik.values[name].url) {
      if (formik.values[name].url.includes('http')) {
        return formik.values[name].url;
      }
      return `${process.env.REACT_APP_API_URL}${formik.values[name].url}`;
    } else if (formik.values[name] instanceof File) {
      return URL.createObjectURL(formik.values[name]);
    }
    return false;
  };

  const imageSrc = getSrc();

  useEffect(() => {
    if (withBoxBg && imageSrc) {
      const img = new Image();
      img.src = imageSrc;
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        const brightness = analyzeImage(img);
        brightness !== null && setBgColor(brightness < 90 ? 'black' : '#D3D3D3');
      };
    }
  }, [imageSrc, withBoxBg]);

  const handleFileUpload = (file) => {
    if (file) {
      if (!formik.values[name] || formik.values[name]?.size !== file.size) {
        formik.setFieldValue(name, file);
      }
    }
  };

  const handleFileCrop = (file) => {
    handleFileUpload(file);
  };

  const handleCropCancel = () => {
    formik.setFieldValue(name, '');
  };

  const [isInfo, setInfo] = useState(false);
  const localOnInfo = () => {
    setInfo(!isInfo);
  };

  return (
    <>
      {useCropper && formik.values[name] && (
        <ImageCropper imageFile={formik.values[name]} onCrop={handleFileCrop} onCancel={handleCropCancel} />
      )}

      <NibFileSelector accept={accept} onUpload={handleFileUpload}>
        {(onClick) => {
          return (
            <div className={'ui-file-selector'}>
              <div className={'ui-file-selector-header'}>
                <strong>{label}</strong>
                <div className="ui-file-selector-header-btns">
                  {helperText && (
                    <IconButton variant={isInfo ? 'secondary' : 'default'} onClick={localOnInfo}>
                      <InfoIcon />
                    </IconButton>
                  )}
                  {withAddBtn && (
                    <IconButton onClick={onClick}>
                      <AddCircle />
                    </IconButton>
                  )}
                </div>
              </div>

              <div className={classnames(css.wrap, 'ui-card-image-wrap')}>
                <div className={classnames(css.box, 'ui-card-image-box')} style={{ backgroundColor: bgColor }}>
                  {desc && <p>{desc}</p>}
                  <div
                    onClick={onClick}
                    className={classnames(
                      css.over,
                      imageSrc ? 'ui-card-image-drop-img' : 'ui-card-image-drop-noimg',
                      'ui-card-image-drop',
                    )}
                  >
                    {customeText && <div>{customeText}</div>}
                    <div>Drop file to upload</div>
                    <div>or</div>
                    <div>
                      <NibButton
                        label="Choose file"
                        mui={true}
                        style={{
                          marginLeft: '0px',
                        }}
                      />
                    </div>
                  </div>

                  {imageSrc && <img src={imageSrc} alt="" />}
                </div>
              </div>

              {isInfo && <p className="ui-help-text">{helperText}</p>}
              {formik.errors[name] && <p className={'customErrorMsg'}>{formik.errors[name]}</p>}
            </div>
          );
        }}
      </NibFileSelector>
    </>
  );
};

export default NInputImage;
